import { render, staticRenderFns } from "./TrainRankingDetail.vue?vue&type=template&id=543204b1&scoped=true"
import script from "./TrainRankingDetail.vue?vue&type=script&lang=js"
export * from "./TrainRankingDetail.vue?vue&type=script&lang=js"
import style0 from "./TrainRankingDetail.vue?vue&type=style&index=0&id=543204b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543204b1",
  null
  
)

export default component.exports